const generateUuid = () => {
  if (window.crypto && typeof window.crypto.randomUUID === "function") {
    return window.crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getDeviceUuid = () => {
  let deviceUuid = localStorage.getItem("teleDeviceUuid");
  if (!deviceUuid) {
    deviceUuid = generateUuid();
    localStorage.setItem("teleDeviceUuid", deviceUuid);
  }
  return deviceUuid;
};
